import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

registerControllers(application, controllers);
